import { render, staticRenderFns } from "./RaBase.vue?vue&type=template&id=496c0d5c&scoped=true"
import script from "./RaBase.vue?vue&type=script&lang=js"
export * from "./RaBase.vue?vue&type=script&lang=js"
import style0 from "./RaBase.vue?vue&type=style&index=0&id=496c0d5c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "496c0d5c",
  null
  
)

export default component.exports